export default __webpack_public_path__ + "static/integrated-mother-tongue-languages-portal-0829a78cbf3d010de00cd43a7026ec2f.jpg";